module.exports = __webpack_public_path__ + "static/media/linux-logo.3e0dfa14.svg";